import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NgClass } from '@angular/common';
import { EditStringModalComponent } from 'app/modules/well-header-information/pages/wells/string/edit-string-modal/edit-string-modal.component';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { StringClass } from 'app/modules/well-header-information/model/wells.model';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-string',
  templateUrl: './string.component.html',
  standalone: true,
  imports: [
    NgClass
  ],
  styleUrls: ['./string.component.scss']
})
export class StringComponent {
  public wellString: StringClass;

  constructor(
    private route: ActivatedRoute,
    private wellHeaderService: WellHeaderInfoService,
    private dialog: MatDialog,
  ) { }
  
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
       let wellStringId = params.get('wellStringId');
       this.getWellString(wellStringId)
     });
   }

  getWellString(id) {
    this.wellHeaderService.getWellString(id).subscribe((res) => {
      this.wellString = {
        wellStringId: res.data.id,
        wellId: res.data.wellId,
        wellboreId: res.data.wellboreId,
        name: res.data.stringShortName,
        longName: res.data.stringLongName, 
        status: res.data.stringStatus,
        tubingSize: res.data.tubingSize,
        createdDate: res.data.inputDate,
        stringIndicatorLongName: res.data.stringIndicatorLongName,
        stringIndicatorShortName: res.data.stringIndicatorShortName,
        level: 'WellString'
      };
    })
  }

  editStringModal(stringData: any) {
    const dialogRef = this.dialog.open(EditStringModalComponent, {
      data: stringData,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.getWellString(stringData.wellStringId)
      }
    });
  }

  handleDateFormat(dateString: string, withTime: boolean = false){
    return handleFormatDate(dateString,withTime)
  }
}
